/** Find the first sibling (matching `itemSelector`) whose vertical midpoint is below `clientY`. */
export function getDragAfterElement<T extends Element>(
  container: Element,
  clientY: number,
  itemSelector: string
): T | null {
  const els = [...container.querySelectorAll<T>(itemSelector)];
  for (const el of els) {
    const box = el.getBoundingClientRect();
    const mid = box.top + box.height / 2;
    if (clientY < mid) return el;
  }
  return null;
}

export const DEFAULT_DRAG_THRESHOLD_PX = 10;

export function dragDistanceExceeded(
  startX: number,
  startY: number,
  clientX: number,
  clientY: number,
  thresholdPx = DEFAULT_DRAG_THRESHOLD_PX
): boolean {
  const dx = clientX - startX;
  const dy = clientY - startY;
  return dx * dx + dy * dy >= thresholdPx * thresholdPx;
}
